import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/returns.scss";

const questions = [
  {
    id: "materials",
    title: "What materials do you use?",
    answer:
      "Materials are listed on every product page. Our current collection uses gold-plated or silver-plated bases, cubic zirconia, and selected freshwater pearls.",
  },
  {
    id: "care",
    title: "How should I care for my jewelry?",
    answer:
      "Keep pieces dry, avoid perfume and household chemicals, and store each item separately in a soft pouch. Gently wipe jewelry with a clean, dry cloth after wear.",
  },
  {
    id: "shipping",
    title: "When will my order ship?",
    answer:
      "Orders are generally packed within 2–3 business days and may require up to 5–7 business days depending on availability. Delivery time begins after processing.",
  },
  {
    id: "tracking",
    title: "How do I track my order?",
    answer:
      "When your order is dispatched, tracking information will be sent to the contact details supplied at checkout.",
  },
  {
    id: "returns",
    title: "Can I return an item?",
    answer:
      "Eligible unworn, unaltered, unused, full-priced merchandise with original packaging may be returned within 14 days of delivery. Sale items are final sale.",
  },
  {
    id: "international",
    title: "Do you ship internationally?",
    answer:
      "International delivery is available to supported destinations. Duties, taxes, and customs charges may be payable by the recipient.",
  },
  {
    id: "support",
    title: "How can I contact Sacuddin?",
    answer: "Email kit@sacuddin.shop and include your order number when your question concerns an existing purchase.",
  },
];

function FAQs() {
  const [expanded, setExpanded] = useState(null);

  return (
    <div className="wrapper--narrow section-padding">
      <div className="text__standard" data-accordion-group="">
        <p className="standard__kicker text-left accent-size-4">FAQs</p>
        {questions.map((item) => (
          <div className="accordion__wrapper" key={item.id}>
            <button
              className="accordion__title"
              onClick={() => setExpanded(expanded === item.id ? null : item.id)}
              aria-expanded={expanded === item.id}
            >
              <span>{item.title}</span>
              <svg
                className={`accordion-icon ${expanded === item.id ? "expanded" : ""}`}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                aria-hidden="true"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
            {expanded === item.id && (
              <div className="accordion__body rte body-size-4">
                <p>{item.answer}</p>
                {item.id === "returns" && <Link to="/returns">Read the full return policy</Link>}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQs;
